import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CreateUser } from '../models/create-user.model';
import { UpdateUser } from '../models/update-user.model';
import { UserFilterParams } from '../models/user-filter-params.model';
import { appConstants } from '../../app-constants';

@Injectable({
	providedIn: 'root',
})
export class UsersService {
	constructor(private router: Router) {}

	buildCreateUserModel(userFormData: CreateUser): CreateUser {
		return {
			...userFormData,
			redirectUrl: `${window.location.href.replace(this.router.url, '')}/auth/set-new-password`,
		};
	}

	buildUpdateUserModel(userId: number, userFormData: UpdateUser): UpdateUser {
		return {
			id: userId,
			title: userFormData?.title || '',
			firstName: userFormData?.firstName,
			lastName: userFormData?.lastName,
			email: userFormData?.email,
			phoneNumber: userFormData?.phoneNumber || '',
			companyName: userFormData?.companyName || null,
			position: userFormData?.position || '',
			roleId: userFormData?.roleId,
			provinceId: userFormData?.provinceId || null,
			nationalityId: userFormData?.nationalityId || null,
			dateOfBirth: userFormData?.dateOfBirth || null,
			status: userFormData?.status || 0,
			gender: userFormData?.gender || null,
		};
	}

	getUserParams(pageSize: number, currentPage: number, filterParams?: UserFilterParams): HttpParams {
		let params = new HttpParams();

		params = params.append(appConstants.QUERY_PARAMS.PAGE_SIZE, pageSize.toString());
		params = params.append(appConstants.QUERY_PARAMS.CURRENT_PAGE, currentPage.toString());

		if (filterParams) {
			Object.entries(filterParams).forEach(([property, value]: [string, any]) => {
				if (value === null || value === undefined) {
					return;
				}

				if (!Array.isArray(value)) {
					params = params.append(property, value);
				} else {
					value.map((items) => {
						params = params.append(property, items.toString());
					});
				}
			});
		}

		return params;
	}
}
